// extracted by mini-css-extract-plugin
export default {"toolbar":"toolbar_toolbar__V1T0c","toolbarSection":"toolbar_toolbarSection__5SU9m","item":"toolbar_item__gojl8"};